var viewer_rtlignore_default = {
  "gallery_container": "LXV0d",
  "imageTitleContainer": "-oStl",
  "clickableItem": "sw-9t",
  "prerender": "_1GVQe",
  "expandContainer": "dVKOd",
  "expandIcon": "WD4Mh",
  "itemOverlay": "BlXSN",
  "imageTitle": "vFco0",
  "pointer": "yZVti",
  "fadeIn": "_8fTm2",
  "changing_background": "L-3mn"
};
export {
  viewer_rtlignore_default as default
};
//# sourceMappingURL=viewer.rtlignore-scss.js.map
